/**
 * Where fountain-conversations points and how it authenticates — see
 * `@managoat/fountain-app/settings`. Stored under `fountain-conversations.settings`, in this
 * browser only.
 */
import { createSettings } from "@managoat/fountain-app/settings";

export { normalizeBaseUrl } from "@managoat/fountain-app/settings";
export type { Settings } from "@managoat/fountain-app/settings";

export const { loadSettings, saveSettings, clearSettings } = createSettings("fountain-conversations");
